import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";
import { rowPerPage } from "../../../components/common/constant";

const initialState = {
  commonDeleteResponse: {
    status: false,
    message: "",
  },
  commonDeleteSucces: false,
  error: "",
  loading: false,
};
export const adminselfLedgerReport = createEncryptedAsyncThunk(
  "adminReportSlice/adminselfLedgerReport",
  // "Wallet/GetLedgerDetail",
  "account/GetLedgerDetailsPage",
  {
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      // ledger_user_id: params.currentUser.userId,
      // service_Id: 0,
      // transaction_type: "",
      // transactionId: params.transactionId || "",
      // status: Array.isArray(params.transactionType)
      //   ? params.transactionType
      //   : [Number(params.transactionType)],
      // req_startDate: params.fromDate,
      // req_endDate: params.toDate,
      userID: params.currentUser.userGuid,
      // ledger_user_id: params.currentUser.userId,
      ledger_user_id: 0,
      service_Id: 0,
      transaction_type: "",
      // transaction_type: "" || params.transactionType,
      // transaction_type: Array.isArray(params.transactionType)
      //   ? String(params.transactionType)
      //   : String(params.transactionType),
      transactionId: params.transactionId || "",
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : [Number(params.transactionType)],
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
      pageSize: params.pageSize || 50,
      pageNumber: params.pageNumber || 1,
      api_user: 3,
    }),
  }
);

export const adminRetailer360Report = createEncryptedAsyncThunk(
  "adminReportSlice/adminLedgerReportPage",
  "account/Retailer360Report",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      transaction_userid: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      startDate: params.fromDate,
      endDate: params.toDate,
    }),
  }
);

export const WalletCheckBalance = createEncryptedAsyncThunk(
  "adminReportSlice/WalletCheckBalance",
  "account/WalletCheckBalance",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: [1, 2, 5, 24, 7],
    }),
  }
);

export const adminLedgerReport = createEncryptedAsyncThunk(
  "adminReportSlice/adminLedgerReport",
  // "Wallet/GetLedgerDetail",
  "account/GetLedgerDetailsPage",
  {
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      // ledger_user_id: params.selectRetailer.value
      //   ? Number(params.selectRetailer.value)
      //   : params.selectRetailer.value,
      // service_Id: 0,
      // transaction_type: "",
      // transactionId: params.transactionId || "",
      // status: Array.isArray(params.transactionType)
      //   ? params.transactionType
      //   : [Number(params.transactionType)],
      // req_startDate: params.fromDate,
      // req_endDate: params.toDate,
      userID: params.currentUser.userGuid,
      // ledger_user_id: params.currentUser.userId,
      ledger_user_id: 0,
      service_Id: 0,
      // transaction_type: "" || params.transactionType,
      transaction_type: Array.isArray(params.transactionType)
        ? String(params.transactionType)
        : String(params.transactionType),
      transactionId: params.transactionId || "",
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : params.status,
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
      pageSize: params.pageSize || 50,
      pageNumber: params.pageNumber || 1,
      api_user: 3,
    }),
  }
);
export const cashoutTransferAmount = createEncryptedAsyncThunk(
  "adminReportSlice/cashoutTransferAmount",
  "account/CashoutRefundWallet",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      tpin: params.tpin || "",
      transactionId: params.txnId,
      // transactionId: params.transactionId,
      // tpin: "1234",
    }),
  }
);
export const GetPendingCashout = createEncryptedAsyncThunk(
  "adminReportSlice/GetPendingCashout",
  "account/GetPendingCashoutByPage",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      service_Id: 0,
      api_id: 0,
      transaction_type: params.transactionType || "",
      transactionId: params.transactionId || "",
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
      pageSize: params.pageSize || 0,
      pageNumber: params.pageNumber || 0,
      status: Array.isArray(params.status)
        ? params.status
        : [Number(params.status)],
    }),
  }
);

export const Get_ICICI_Account_Statement_Report = createEncryptedAsyncThunk(
  "adminReportSlice/Get_ICICI_Account_Statement_Report",
  "account/GetICICI_AccountStatementReport",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      serviceId: 7,
      fromdate: params.fromDate,
      todate: params.toDate,
    }),
  }
);

export const GetDMTTransactionReports = createEncryptedAsyncThunk(
  "adminReportSlice/GetDMTTransactionReports",
  "account/GetDMTTransactionPage",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      dmt_transaction_userid: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      pageless: params.pageless || false,
      txn_type: params.transactionType || "",
      txn_id: params.transactionId || "",
      status: Array.isArray(params.status)
        ? params.status
        : [Number(params.status)],
      pageSize: params.pageSize || 0,
      pageNumber: params.pageNumber || 0,
      startDate: params.fromDate,
      endDate: params.toDate,
      utr: params.utr || "",
      mobileNo: params.beneficiaryMobileNumber || "",
      accountNo: params.accountnumber || "",
      ifsc: params.ifsccode || "",
    }),
  }
);
export const getExcelDMTTransectionDetail = createEncryptedAsyncThunk(
  "adminReportSlice/getExcelLedgerDetail",
  "account/GetExcelDMTDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      dmt_userid: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      transaction_type: params.transaction_type || "",
      transactionId: params.transactionId || "",
      status: Array.isArray(params.status)
        ? params.status
        : [Number(params.status)],
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const adminLedgerReportPage = createEncryptedAsyncThunk(
  "adminReportSlice/adminLedgerReportPage",
  "account/GetLedgerDetailsPage",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      service_Id: params.serviceId || 0,
      api_id: params.apiId || 0,
      transaction_type: params.transactionType || "",
      // transaction_type: String(params.transactionType) || "",
      transactionId: params.transactionId || "",
      refundCheck: params.refundCheck || false,
      status: Array.isArray(params.status)
        ? params.status
        : [Number(params.status)],
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
      pageSize: params.pageSize || 50,
      pageNumber: params.pageNumber || 1,
      utr:params.utr,
    }),
  }
);

export const getLedgerDetailsGST = createEncryptedAsyncThunk(
  "adminReportSlice/adminLedgerReportPage",
  "Wallet/GetLedgerGSTDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      service_Id: 0,
      transaction_type: params.transactionType || "",
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const getLedgerDetailsTDS = createEncryptedAsyncThunk(
  "adminReportSlice/adminLedgerReportPage",
  "Wallet/GetLedgerTDSDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      service_Id: 0,
      transaction_type: params.transactionType || "",
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const getExcelLedgerDetail = createEncryptedAsyncThunk(
  "adminReportSlice/getExcelLedgerDetail",
  "account/GetExcelLedgerDetail",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      service_Id: 0,
      transaction_type: "",
      transactionId: params.transactionId || "",
      // status: Array.isArray(params.transactionType)
      //   ? params.transactionType
      //   : [Number(params.transactionType)],
      status: params.status || [0, 1, 2, 3],
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const adminCommissionLedgerReport = createEncryptedAsyncThunk(
  "adminReportSlice/adminCommissionLedgerReport",
  // "Wallet/GetLedgerDetail",
  "account/GetLedgerDetailsPage",
  {
    prepareBody: (params) => ({
      // userID: params.currentUser.userGuid,
      // ledger_user_id: Number(
      //   params.selectRetailer.value || params.currentUser.userId
      // ),
      // service_Id: 0,
      // transaction_type: "",
      // transactionId: "",
      // status: Array.isArray(params.transactionType)
      //   ? params.transactionType
      //   : [Number(params.transactionType)],
      // req_startDate: params.fromDate,
      // req_endDate: params.toDate,
      userID: params.currentUser.userGuid,
      ledger_user_id: Number(params.selectRetailer.value),
      service_Id: 0,
      transaction_type: "",
      // transaction_type: "" || params.transactionType,
      // transaction_type: Array.isArray(params.transactionType)
      //   ? String(params.transactionType)
      //   : String(params.transactionType),
      transactionId: params.transactionId || "",
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : [Number(params.transactionType)],
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
      pageSize: params.pageSize || 50,
      pageNumber: params.pageNumber || 1,
      api_user: 3,
    }),
  }
);
export const adminLedgerReconsileReport = createEncryptedAsyncThunk(
  "adminReportSlice/adminLedgerReconsileReport",
  "Wallet/GetLedgerDetailsReconsile",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: Number(params.selectRetailer.value),
      service_Id: 0,
      transaction_type: "",
      transactionId: "",
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : [Number(params.transactionType)],
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);

export const adminAccountStatusReports = createEncryptedAsyncThunk(
  "adminReportSlice/adminAccountStatusReports",
  "Wallet/GetLedgerAccountStatusReport",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer,
      service_Id: 19,
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const checkBankStatus = createEncryptedAsyncThunk(
  "adminReportSlice/checkBankStatus",
  "account/DMT_TransactionStatusCheckAPIDirect",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      merchantCode: params.data.merchantCode,
      clientId: params.data.clientId,
      clientSecretKey: params.data.clientSecretKey,
      transactionId: params.data.txn_id,
      updateTransactionFlag: true,
    }),
  }
);

export const getDailyPayinPayoutReport = createEncryptedAsyncThunk(
  "adminReportSlice/getDailyPayinPayoutReport",
  "account/GetDailyPayout_PayinReport",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      reportUserId: params.selectDistributor.value,
      fromDate: params.fromDate,
      toDate: params.toDate,
    }),
  }
);

export const adminFullDayReport = createEncryptedAsyncThunk(
  "adminReportSlice/adminFullDayReport",
  "Wallet/GetLedgerDetail",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer.value,
      service_Id: 0,
      transaction_type: "",
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const getWalletReportHistory = createEncryptedAsyncThunk(
  "adminReportSlice/getWalletReportHistory",
  "Wallet/GetLedgerDetail",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: params.selectRetailer.value,
      service_Id: 0,
      transaction_type: "",
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const adminBillPaymentReport = createEncryptedAsyncThunk(
  "adminReportSlice/adminBillPaymentReport",
  "account/GetBBPSReport",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      bbps_userid:
        params.selectRetailer.value === 0
          ? 0
          : Number(params.selectRetailer.value),
      txn_id: params.txn_id || "",
      txn_type: "",
      txn_mode: params.txn_mode || "",
      customerNo: "",
      startDate: params.fromDate,
      endDate: params.toDate,
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : [Number(params.transactionType)],
    }),
  }
);
export const OutStandingReports = createEncryptedAsyncThunk(
  "adminReportSlice/OutStandingReports",
  "Service/OutstandingReport",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userId: params.currentUser.userId,
      role: params.selectRole.value,
    }),
  }
);
export const getAdminWalletToWallet = createEncryptedAsyncThunk(
  "adminReportSlice/getAdminWalletToWallet",
  "account/GetWalletTransfer",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      pG_transaction_userid: Number(params.selectDistributor.value) || 0,
      startDate: params.fromDate ? params.fromDate : "",
      endDate: params.toDate ? params.toDate : "",
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : [Number(params.transactionType)],
    }),
  }
);
export const getRetailerList = createEncryptedAsyncThunk(
  "adminReportSlice/adminBillPaymentReport",
  (params) =>
    `/Reports/UserLedgerReport?MobileNo=${params.selectRetailer.mobile}&FromDate=${params.fromDate}&ToDate=${params.toDate}&Role=${params.Role}`,
  {
    method: "GET",
  }
);
export const getAdminMoneyTransactionHistoryHold = createEncryptedAsyncThunk(
  "adminReportSlice/getAdminMoneyTransactionHistoryHold",
  "account/GetDMTTransaction",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      txn_id: "",
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : [Number(params.transactionType)],
      dmt_transaction_userid: Number(params.selectDistributor.value) || 0,
      startDate: params.fromDate ? params.fromDate : "",
      endDate: params.toDate ? params.toDate : "",
    }),
  }
);
export const getAdminNewMoneyTransactionHistoryHold = createEncryptedAsyncThunk(
  "adminReportSlice/getAdminNewMoneyTransactionHistoryHold",
  "account/GetDMTTransaction",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      txn_id: "",
      status: Array.isArray(params.transactionType)
        ? params.transactionType
        : [Number(params.transactionType)],
      dmt_transaction_userid: Number(params.selectDistributor.value) || 0,
      startDate: params.fromDate ? params.fromDate : "",
      endDate: params.toDate ? params.toDate : "",
    }),
  }
);
export const checkBankStatusDmt = createEncryptedAsyncThunk(
  "adminReportSlice/checkBankStatus",
  "account/DMT_TransactionStatusCheckAPIDirect",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      merchantCode: params.data.merchantCode,
      clientId: params.data.clientID,
      clientSecretKey: params.data.clientSecretKey,
      transactionId: params.data.transaction_Id,
      updateTransactionFlag: true,
    }),
  }
);
export const AdminAEPSTransactionReports = createEncryptedAsyncThunk(
  "reportSlice/AdminAEPSTransactionReports",
  "account/GetAEPSReport",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      report_userid: params.selectRetailer.value || params.currentUser.userId,
      txn_id: "",
      apiId: 0,
      startDate: params.fromDate,
      endDate: params.toDate,
      status: Array.isArray(params.status)
        ? params.status
        : [Number(params.status)],
    }),
  }
);
export const confirmSuccessManuallyold = createEncryptedAsyncThunk(
  "adminReportSlice/confirmSuccessManually",
  "Transaction/UpdateTransStatus",
  {
    prepareBody: (params) => ({
      walletId: params.dmtId,
      status: 1,
      userID: 85,
    }),
  }
);

export const confirmSuccessManually = createEncryptedAsyncThunk(
  "adminReportSlice/confirmSuccessManually",
  "account/UpdateTrasactionStatus",
  {
    prepareBody: (params) => ({
      // walletId: params.dmtId,
      // status: 1,
      // userID: 85,
      transactionId: params.dmtId,
      status: 1,
      userID: params.currentUser.userId,
      service_Type: "string",
      utr: "string",
      service_Id: 0,
      tpin: "string",
      walletType: "string",
    }),
  }
);

export const adminGetAPIRequestResponseLog = createEncryptedAsyncThunk(
  "adminReportSlice/adminGetAPIRequestResponseLog",
  "Service/GetAPIRequestResponseLog",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      reference_Id: params.referenceId || "",
      requestLike: params.requestLike || "",
      responseLike: params.responseLike || "",
      service_Id: params.serviceId || 0,
      reportUserId: params.reportUserId || 0,
      transaction_type: params.serviceType || params.transaction_type || "",
      skipschedulerLogs: params.skipschedulerLogs || false,
      startDate: params.fromDate,
      endDate: params.toDate,
      pageNo: params.pageNumber || 1,
      pageSize: params.pageSize || rowPerPage,
    }),
  }
);

export const getSMSLogs = createEncryptedAsyncThunk(
  "adminReportSlice/getSMSLogs",
  "account/GetSMSLog",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      smstype: params.selectTemplate.label || "",
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);

export const ReverseTrasactionAction = createEncryptedAsyncThunk(
  "adminReportSlice/ReverseTrasaction",
  "account/ReverseTrasaction",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      transactionId: params.transaction_Id,
      userID: params.currentUser.userGuid,
      service_Type: params.service_Type || "",
      service_Id: params.service_Id || 0,
      walletType: "1",
    }),
  }
);

export const confirmFailedManually = createEncryptedAsyncThunk(
  "adminReportSlice/confirmFailedManually",
  "Transaction/UpdateTransStatus",
  {
    prepareBody: (params) => ({
      walletId: params.dmtId,
      status: 3,
      userID: 85,
    }),
  }
);
export const kycPayementReports = createEncryptedAsyncThunk(
  "adminReportSlice/confirmFailedManually",
  "account/CFPGGetAllPG",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      pG_transaction_userid: params.currentUser.userId,
      transactionid: "",
      startDate: params.fromDate,
      endDate: params.toDate,
      status: [0, 1, 2],
    }),
  }
);
export const getTopUpTransectionHistory = createEncryptedAsyncThunk(
  "reportSlice/getTopUpTransectionHistory",
  "account/GetTopUpReport",
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      // reportUserId: Number(params.selectRetailer.value),
      reportUserId: params.selectRetailer
        ? Number(params.selectRetailer.value)
        : 0,
      adminTopup: params.adminTopupFlag,
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  }
);
export const businessAnalysisReport = createEncryptedAsyncThunk(
  "reportSlice/businessAnalysisReport",
  "account/GetBalAnalysReport",
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      endDate: params.toDate,
    }),
  }
);

export const businessAdminReport = createEncryptedAsyncThunk(
  "reportSlice/businessAdminReport",
  "account/GetBusinessReport",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      reportUserId: params.selectRetailer
        ? Number(params.selectRetailer.value)
        : 0,
      fromDate: params.fromDate,
      toDate: params.toDate,
    }),
  }
);

export const GetDailyBusinessReport = createEncryptedAsyncThunk(
  "reportSlice/businessAnalysisReport",
  "account/GetDailyBusinessReport",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      reportUserId: params.reportUserId || 0,
      fromDate: params.fromDate,
      toDate: params.toDate,
    }),
  }
);
export const updateSchedulerStatus = createEncryptedAsyncThunk(
  "adminReportSlice/updateSchedulerStatus",
  "Service/UpdateSchedulerStatus",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      schdeulerName: params.schdeulerName || "",
      status: params.status || "0",
      runningStatus: params.runningStatus || "0",
    }),
  }
);
export const getSchedulerDetails = createEncryptedAsyncThunk(
  "adminReportSlice/getSchedulerDetails",
  "Service/GetSchedulerDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      schdeulerName: params.schdeulerName || "",
    }),
  }
);
export const getLiveTransactionReports = createEncryptedAsyncThunk(
  "adminReportSlice/getLiveTransactionReports",
  "Service/GetLiveTransaction",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      report_userId: params.selectRetailer.value
        ? Number(params.selectRetailer.value)
        : params.selectRetailer.value,
      service_id: 0,
      api_id: 0,
      status: params.transactionType,
      // status: [0, -1, 1, 2],
      startDate: params.fromDate,
      endDate: params.toDate,
      pageSize: params.pageSize || 0,
      pageNumber: params.pageNumber || 0,
    }),
  }
);
export const updateTransactionStatus = createEncryptedAsyncThunk(
  "adminReportSlice/updateTransactionStatus",
  "account/UpdateTrasactionStatus",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      transactionId: params.transaction_Id,
      status: params.status,
      userID: params.currentUser.userGuid,
      service_Type: params.service_Type || "",
      utr: params.utr || "",
      tpin: params.tpin || "",
      service_Id: params.service_Id || 0,
      walletType: params.walletType || "1",
    }),
  }
);
export const GetPendingCashoutDirectAPI = createEncryptedAsyncThunk(
  "adminReportSlice/GetPendingCashoutDirectAPI",
  "Service/GetRefundPendingClaim",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      reportUserId: params.reportUserId || 0,
      fromDate: params.fromDate || "",
      toDate: params.toDate || "",
      role_Id: [1],
      masterDatakey: "PAYSPRINTREFUNDPENDING",
      status: params.status,
    }),
  }
);
export const setOtpForCliamRefund = createEncryptedAsyncThunk(
  "adminReportSlice/setOtpForCliamRefund",
  "transaction/RefundOTP",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      referenceid: params.referenceid || 0,
      ackno: params.ackno || 0,
      transactionID: params.transactionID,
      serviceId: params.serviceId || 0,
    }),
  }
);
export const cashoutTransferAmountDirectAPI = createEncryptedAsyncThunk(
  "adminReportSlice/cashoutTransferAmountDirectAPI",
  "transaction/ClaimRefund",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      referenceid: params.referenceid || 0,
      ackno: params.ackno || 0,
      otp: params.otp || 0,
      otpToken: params.otpToken || "",
      transactionID: params.transactionID,
      serviceId: params.serviceId || 0,
    }),
  }
);

export const adminReportSlice = createSlice({
  name: "adminReportSlice",
  initialState,
  reducers: {
    FetchSuccess(state, action) {
      return { ...state, recharge: action.payload.Data[0] };
    },
    FetchFailed(state, action) {
      return {
        ...state,
        rechargeResponse: { status: true, message: action.payload },
      };
    },
    DeleteSuccess(state) {
      return { ...state, loading: false, commonDeleteSucces: true };
    },
    DeleteFailed(state, action) {
      return {
        ...state,
        fetchError: false,
        commonDeleteResponse: { status: true, message: action.payload },
      };
    },
    DeleteInitial(state) {
      return {
        ...state,
        commonDeleteSucces: false,
        commonDeleteResponse: { status: false, message: "" },
      };
    },
  },
});
export const {
  FetchSuccess,
  FetchFailed,
  DeleteSuccess,
  DeleteFailed,
  DeleteInitial,
} = adminReportSlice.actions;
export default adminReportSlice.reducer;
